import {useState} from 'react';
import {Question} from '@agenium-ai/agenium-client-sdk/dist/models';
import MultipleChoiceSingleInput from './MultipleChoiceSingleInput';

export interface HeightInputProps {
    question: Question;
    onChange?: (s: string | number) => void;
    value: number;
    type?: 'text' | 'numeric';
}

const HeightInput = (props: HeightInputProps) => {
    const {question, onChange, value} = props;
    const heights = [{displayName: `< 4'8"`, id: 55}].concat(
        Array.from({length: 40}, (_, i) => {
            const offset1 = 4;
            const offset2 = 8;
            const inOne = 12;
            const displayName = `${+`${(i + offset2) / inOne}`[0] + offset1}'${(i + offset2) % inOne}"`;
            return {displayName, id: 56 + i};
        }),
    );
    const handleChange = (value: string | number) => {
        onChange?.(value);
    };

    return (
        <MultipleChoiceSingleInput
            value={value ?? ''}
            onChange={handleChange}
            question={{...question, allowedValues: heights as any}}
        />
    );
};

export default HeightInput;
